import { render, staticRenderFns } from "./FormacaoCargaView.vue?vue&type=template&id=52595bc4&"
import script from "./FormacaoCargaView.vue?vue&type=script&lang=js&"
export * from "./FormacaoCargaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports